module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chaptitle"
  }, [_c('span', [_c('a', {
    attrs: {
      "id": "pagexii"
    }
  }), _c('b', [_vm._v("ILLUSTRATIONS")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill2"
  }, [_c('span', [_vm._v("A Cavalryman from the Trans-Mississippi")])]), _vm._v(" "), _c('div', {
    staticClass: "ill2"
  }, [_c('span', [_vm._v("Plates")])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla1",
      "id": "rpla1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1.  Ben McCulloch, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla1-1",
      "id": "rpla1-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Henry E. McCulloch, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla1-2",
      "id": "rpla1-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James McIntosh, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla1-3",
      "id": "rpla1-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Thomas J. Churchill, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla2",
      "id": "rpla2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2.  Stand Watie, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla3",
      "id": "rpla3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3.  Henry Hopkins Sibley, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla4",
      "id": "rpla4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4.  Earl Van Dorn, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla5",
      "id": "rpla5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5.  Theophilus H. Holmes, Lieutenant General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla6",
      "id": "rpla6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6.  Thomas C. Hindman, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla7",
      "id": "rpla7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7.  John A. Wharton, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla7-1",
      "id": "rpla7-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Xavier Blanchard De Bray, Brigadier General (not approved by President Davis)")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla7-2",
      "id": "rpla7-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("James F. Fagan, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill1"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla7-3",
      "id": "rpla7-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("William P. Steele, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla8",
      "id": "rpla8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8.  John Sappington Marmaduke, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla9",
      "id": "rpla9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9.  Joseph Orville Shelby, Brigadier General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla10",
      "id": "rpla10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10.  Sterling Price, Major General")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla11",
      "id": "rpla11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11.  John S. Ford, Colonel")])])]), _vm._v(" "), _c('div', {
    staticClass: "ill"
  }, [_c('span', [_c('span', {
    attrs: {
      "href": "#/plates#pla12",
      "id": "rpla12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12.  Edmund Kirby Smith, Lieutenant General")])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c438c26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/illustration.vue
// module id = 78
// module chunks = 0